import Api from "./api";
import OidcManager from "./oidcManager";
import {QboAccount} from "./qbo";
import {QbMode} from "../../components/qbo-progressive-popup/qbo-progressive-popup";

export interface QboExportResult {
    isSuccess: boolean;
    errorCode: number;
    errorMessage?: string;
    invoiceId?: string;
    content?: any;
    customerId?: string;
    customerName?: string;
    fileName?: string;
}

export interface QboCompletionPercent {
    rowId: string,
    percentComplete: number
}

export class Reports extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    export(command: {estimateId: number, showPerUnit: boolean, doubleSpaceLines: boolean,
        hideComponentCosts: boolean, format: number}): JQueryPromise<any> {
        return super.getBlob("/api/reports/export", command);
    }
    
    pdf(command: {estimateId: number, showPerUnit: boolean, doubleSpaceLines: boolean,
        hideComponentCosts: boolean}): JQueryPromise<any> {
        return super.getBlob("/api/reports/pdf", command);
    }

    qb(command: {
        estimateId: number,
        materialCosts: number,
        laborCosts: number,
        equipmentCosts: number,
        totalOnlyCosts: number,
        itemTotalsOnly: boolean,
        omitWorkDescriptions: boolean,
        markupCosts: number,
        taxCosts: number
    }): JQueryPromise<QboExportResult> {
        return super.get("/api/reports/qb", command);
    }

    qbo(command: {
        estimateId: number,
        materialCosts: number,
        laborCosts: number,
        equipmentCosts: number,
        totalOnlyCosts: number,
        itemTotalsOnly: boolean,
        omitWorkDescriptions: boolean,
        markupCosts: number,
        taxCosts: number,
        qboCustomerId: string
    }): JQueryPromise<QboExportResult> {
        return super.get("/api/qbo/export", command);
    }

    excel(command: {
        estimateId: number,
        materialCosts: number,
        laborCosts: number,
        equipmentCosts: number,
        totalOnlyCosts: number,
        itemTotalsOnly: boolean,
        omitWorkDescriptions: boolean,
        markupCosts: number,
        taxCosts: number,
        typeOfExport:string
    }): JQueryPromise<any> {
        return super.getBlob("/api/reports/excel", command);
    }
    
    saveSettings(command: {
        estimateId: number,
        materialCosts: number,
        laborCosts: number,
        equipmentCosts: number,
        totalOnlyCosts: number,
        itemTotalsOnly: boolean,
        omitWorkDescriptions: boolean,
        markupCosts: number,
        taxCosts: number,
        qboCustomerId: string
    }): JQueryPromise<any> {
        return super.get("/api/qbo/save-settings", command);
    }
    
    qbProgressive(command: {
        estimateId: number,
        mode: QbMode,
        completionPercentages: QboCompletionPercent[]
    }): JQueryPromise<QboExportResult> {
        return super.post("/api/qbo/progressive-export", command);
    }

    excelProgressive(command: {
        estimateId: number,
        completionPercentages: QboCompletionPercent[]
    }): JQueryPromise<any> {
        return super.postBlob("/api/qbo/progressive-export-excel", command);
    }

    resetPercentages(command: {
        estimateId: number
    }): JQueryPromise<any> {
        return super.post("/api/qbo/reset-percentages", command);
    }
    
    exportBid(command: {
        estimateId: number,
        materialCosts: number,
        laborCosts: number,
        equipmentCosts: number,
        totalOnlyCosts: number,
        itemTotalsOnly: boolean,
        omitWorkDescriptions: boolean,
        markupCosts: number,
        taxCosts: number,
        format: number
    }): JQueryPromise<any> {
        console.log("exportBid", command);
        return super.getBlob("/api/reports/exportBid", command);
    }

    getBidFormat(command: {
        estimateId: number
    }): JQueryPromise<any> {
        console.log("getBidFormat", command);
        return super.get("/api/reports/bidFormat", command);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/reports.ts